import axios from "axios";
import * as actionTypes from "./actionTypes";
import { openError } from "./notification";


export const authStart = () =>
({
  type: actionTypes.AUTH_START
})


export const authSuccess = token => ({
  type: actionTypes.AUTH_SUCCESS,
  token
})

export const authFail = error => ({
  type: actionTypes.AUTH_FAIL,
  error
})

export const logout = () => {
  localStorage.removeItem("admin-token");
  localStorage.removeItem("admin-expirationDate");
  // Only clear saved credentials if Remember Me was not set
  if (localStorage.getItem("admin-rememberMe") !== "true") {
    localStorage.removeItem("admin-savedEmail");
    localStorage.removeItem("admin-savedPwd");
    localStorage.removeItem("admin-rememberMe");
  }
  return {
    type: actionTypes.AUTH_LOGOUT
  };
};

// setTimeout max is ~24.8 days (2^31 - 1 ms). Skip timeout for longer durations.
const MAX_TIMEOUT = 2147483647;
let authTimeoutId = null;

export const checkAuthTimeout = expirationTime =>
  dispatch => {
    // Clear any existing timeout to prevent stacking
    if (authTimeoutId) clearTimeout(authTimeoutId);
    const delayMs = expirationTime * 1000;
    if (delayMs > MAX_TIMEOUT) return;
    authTimeoutId = setTimeout(() => {
      dispatch(logout());
    }, delayMs);
  };

export const authLogin = (username, password, rememberMe, callback) =>
  dispatch => {

    dispatch(authStart());
    axios
      .post(`${process.env.REACT_APP_SERVER_URL}api/user/admin-token-auth/`, {
        username,
        password
      })
      .then(res => {
        if (res.data.token) {
          const token = `${res.data.token}`;
          // Remember me: 30 days, otherwise: 1 hour
          const expirationMs = rememberMe ? 30 * 24 * 3600 * 1000 : 3600 * 1000;
          const expirationDate = new Date(new Date().getTime() + expirationMs);
          localStorage.setItem("admin-token", token);
          localStorage.setItem("admin-expirationDate", expirationDate);
          localStorage.setItem("admin-rememberMe", rememberMe ? "true" : "false");
          dispatch(authSuccess(token));
          dispatch(checkAuthTimeout(expirationMs / 1000));
          callback(res);

        } else {
          dispatch(authFail(res.data.message));
        }

      })
      .catch(err => {
        console.log('error: ', err);
        dispatch(authFail({ err }));
        dispatch(openError(true, "Error!", `${err.response?.data?.message || 'Login Failed'}`, ""))
      });
  }


export const authSignup = (username, email, password1, password2, userrole, callback) =>
  dispatch => {

    dispatch(authStart());
    axios
      .post(`${process.env.REACT_APP_SERVER_URL}api/user/create`, {
        username,
        email,
        password: password1,
        password2,
        role_position: userrole
      })
      .then(res => {
        callback({ res, success: "success" });
      })
      .catch(err => {
        dispatch(authFail(err));
        callback(err);
      });

  };


export const authCheckState = () => dispatch => {

  const token = localStorage.getItem("admin-token");
  if (!token) {
    dispatch(logout());
  } else {
    const expirationDate = new Date(localStorage.getItem("admin-expirationDate"));
    if (expirationDate <= new Date()) {
      dispatch(logout());
    } else {
      dispatch(authSuccess(token));
      dispatch(
        checkAuthTimeout(
          (expirationDate.getTime() - new Date().getTime()) / 1000
        )
      );
    }
  }

};



